import { FC } from "react";
import { Modal } from "@monolith-forensics/monolith-ui";

import CreateInquiryForm from "../Forms/CreateInquiryForm";

interface CreateInquiryModalProps {
  show: boolean;
  onClose: () => void;
  onSubmit?: (result?: unknown) => void;
  onCancel?: () => void;
}

export const CreateInquiryModal: FC<CreateInquiryModalProps> = ({
  show,
  onClose,
  onSubmit,
  onCancel,
}) => {
  const handleSubmit = (result?: unknown) => {
    onSubmit?.(result);
    onClose();
  };

  const handleCancel = () => {
    onCancel?.();
    onClose();
  };

  return (
    <Modal open={show} onClose={handleCancel}>
      <CreateInquiryForm
        width={700}
        onSubmit={handleSubmit}
        onCancel={handleCancel}
      />
    </Modal>
  );
};

export default CreateInquiryModal;
